<template>
    <div>
        <div class="patient-info" v-for="(item, index) in list" :key="item.id" v-watermark>
            <div class="patient-info-header">
                <div class="left">
                    <div class="name">患者信息</div>
                    <div class="relation" v-if="item.existEmrFlag == 1">
                        <van-popover v-model="relation.show[index]" trigger="click" placement="bottom">
                            <div class="relation-list">
                                <div class="itm">
                                    <van-button type="info" size="mini" @click="onRelation(item)">前往关联</van-button>
                                </div>
                                <div class="itm">
                                    <van-button size="mini" @click="onRelationNeverRemind(item)"
                                        :disabled="!relation.submit">不再提示</van-button>
                                </div>
                            </div>
                            <template #reference>
                                <van-button type="danger" size="mini">有同名病历</van-button>
                            </template>
                        </van-popover>
                    </div>
                </div>
                <div class="right">
                    <!-- <van-button class="call" type="primary" round @click="onCall(item)" :disabled="getOlaState.olaDisabled || !$store.state.userInfo.extNo">
                        呼叫
                    </van-button> -->
                    <van-button class="coupon" type="primary" round @click="onGetCoupon(item)">代领券</van-button>
                </div>
            </div>
            <div class="patient-info-content">
                <div class="vip-equity" v-if="item.memberRightsInterests">
                    <vip :id="item.id" :detail="item.memberRightsInterests" :is-view="true" />
                </div>
                <div class="vip-equity" v-if="item.channelRights">
                    <VipChannel :detail="item.channelRights" />
                </div>
                <div class="cells">
                    <div class="cell full">
                        <span class="label">患者编号</span>
                        <span>{{ item.memberNo || "" }}</span>
                    </div>
                    <div class="cell full">
                        <span class="label">用户编号</span>
                        <span>{{ item.userNo || "" }}{{ item.nickName ? `（${item.nickName}）` : '' }}</span>
                    </div>
                    <div class="cell">
                        <span class="label">姓名</span>
                        <span style="">{{ item.name }}</span>
                    </div>
                    <div class="cell">
                        <span class="label">年龄</span>
                        <span>{{ item.age }}岁</span>
                    </div>
                    <div class="cell">
                        <span class="label">性别</span>
                        <span>{{ item.sex | sexFilter(item.sex) }}</span>
                    </div>
                    <div class="cell">
                        <span class="label">手机号</span>
                        <span>{{ item.mobile }}</span>
                    </div>
                    <div class="cell">
                        <span class="label">关系</span>
                        <span>{{ item.relation | relationFilter(item.relation) }}</span>
                    </div>
                    <div class="cell">
                        <span class="label">城市</span>
                        <span>{{ item.province || item.address }}</span>
                    </div>
                    <div class="cell">
                        <span class="label">绑定医生</span>
                        <span>{{ item.doctorName || '无' }}</span>
                    </div>
                    <!-- <div class="cell">
                        <span class="label">状态</span>
                        <span>
                            <ask-status :status="item.latestAskState" :exist-address="item.existAddress == 1" />
                        </span>
                    </div> -->
                    <div class="cell">
                        <span class="label">绑定医助</span>
                        <span>{{ item.assistantName || '无' }}</span>
                    </div>
                </div>
            </div>
            <div class="patient-info-footer">
                <div class="follow-up" @click="trackRecord(item)">跟进记录</div>
                <div class="inquiry" @click="inquiryRecord(item.id)">问诊记录</div>
                <div class="medicated" @click="onSubscribe(item)" v-if="getLoginRole === '医助'">预约</div>
                <!-- <div class="tracking" @click="efficacyTracking(item.id)">疗效跟踪</div> -->
                <!-- <div class="createAsk" @click="onCreatePreAsk(item)">快速问诊</div> -->
                <div class="more" @click="patientInfo(item.id)">查看更多</div>
            </div>
        </div>
        <div class="pagination" v-if="total > pageSize">
            <van-pagination v-model="pageNo" :total-items="total" :items-per-page="pageSize" @change="pageChange">
                <template #prev-text>
                    <van-icon name="arrow-left" />
                </template>
                <template #next-text>
                    <van-icon name="arrow" />
                </template>
                <template #page="{ text }">{{ text }}</template>
            </van-pagination>
        </div>
        <receive-coupon :show.sync="receiveCouponState.show" :userNo="receiveCouponState.userNo" />
    </div>
</template>
<script>
import weChatMixin from '@/mixin/weChat.js'
import request from '@/utils/request.js'
import askStatus from '@/components/ask/status.vue'
import vip from '@/components/vip/index.vue'
import VipChannel from '@/components/vip/channel.vue'
import ReceiveCoupon from '@/components/coupon/receiveCoupon.vue'

import eventBus from '@/hooks/eventBus'

import { mapGetters } from 'vuex';
export default {
    mixins: [weChatMixin],
    components: {
        askStatus,
        vip,
        ReceiveCoupon,
        VipChannel
    },
    props: {
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 5
        },
        list: {
            type: Array
        },
        showTag: Boolean
    },
    watch: {
        currentPage(val) {
            this.pageNo = val
        }
    },
    data() {
        return {
            pageNo: 1,
            relation: {
                show: [],
                submit: true
            },
            receiveCouponState: {
                show: false,
                userNo: null,
            },
        }
    },
    methods: {
        pageChange(val) {
            this.$emit('pageChange', val)
        },
        trackRecord(item) {
            this.$router.push({
                path: '/trackRecord',
                query: {
                    userNo: item.userNo,
                    userMemberId: item.id,
                    userMemberName: item.name,
                    currentId: 1
                }
            })
        },
        inquiryRecord(id) {
            this.$router.push({
                path: '/inquiryRecord',
                query: {
                    userMemberId: id,
                    pageNo: 1
                }
            })
        },
        efficacyTracking(id) {
            this.$router.push({
                name: 'MoreEffective',
                query: {
                    id
                },
            })
        },
        onSubscribe(row) {
            this.$router.push({
                name: 'Reservation',
                query: {
                    userMemberId: row.userMemberHealth.userMemberId,
                    doctorNo: row.doctorNo,
                }
            })
        },
        patientInfo(id) {
            this.$router.push({
                path: '/patientInfo',
                query: {
                    id: id
                }
            })
        },
        onCreatePreAsk(item) {
            if ([0, 1, 2].includes(item.latestAskState)) return this.$toast('存在未完成的问诊');
            this.$router.push({
                path: '/createAsk',
                query: {
                    askType: 12,
                    userNo: item.userNo,
                    userMemberId: item.id,
                    assistantNo: this.$store.state.assistantNo
                }
            })
        },
        onRelation(row) {
            let url = window.location.href.split('#')[0]
            this.wxAgentConfig(url, ['openDefaultBrowser'], () => {
                wx.invoke('openDefaultBrowser', {
                    // 'url': "https://open.weixin.qq.com/connect/oauth2/authorize?appid=CORPID&redirect_uri=REDIRECT_URI&response_type=code&scope=SCOPE&agentid=AGENTID&state=STATE#wechat_redirect", // 在默认浏览器打开redirect_uri，并附加code参数；也可以直接指定要打开的url，此时不会附带上code参数。
                    url: process.env.VUE_APP_APP_RELATION_HOST + '/#/patientInfo/medicalRecordConnect?id=' + row.id + '&mode=relation'
                }, (res) => {
                    if (res.err_msg != "openDefaultBrowser:ok") {
                        //错误处理
                        this.$toast.fail('浏览器打开失败')
                        this.relation.show = [];
                    } else {
                        this.$toast.success('浏览器打开成功')
                        this.relation.show = [];
                    }
                });
            })
        },
        onRelationNeverRemind(row) { // 不再提醒
            if (!this.relation.submit) return false;
            this.$dialog.confirm({
                title: '确认后，有同名病历的提示则不再显示？',
                message: '',
            }).then(() => {
                this.relation.submit = false;
                request({
                    url: '/emr-import-service/mr/not_remind',
                    method: 'post',
                    data: {
                        userMemberId: row.id,
                        userMemberName: row.name
                    }
                }).then(() => {
                    this.$toast.success('设置成功');
                    setTimeout(() => {
                        this.relation.show = [];
                        this.relation.submit = true;
                        this.$emit('init');
                    }, 1000)
                }).catch(() => {
                    this.relation.submit = true;
                    this.$toast.fail('设置失败');
                })
            }).catch(() => {

            });
        },
        onGetCoupon(item) {
            this.receiveCouponState = {
                show: true,
                userNo: item.userNo,
            }
        },
        onCall(item) {
            eventBus.emit('olaDial', '', item.mobile)
        }
    },
    computed: {
        ...mapGetters(['getLoginRole', 'getOlaState']),
    },
}
</script>
<style lang="scss" scoped>
.patient-info {
    margin-top: 10px;
    background: #fff;
    border-radius: 4px;

    .patient-info-header {
        padding: 22px 26px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            display: flex;
            align-items: center;

            .name {
                font-size: 18px;
                font-weight: bold;
            }
        }

        .right {
            display: flex;

            .coupon,
            .call {
                color: #0082EF;
                background: #f5f5f5;
                padding: 6px 14px;
                margin: 0;
                text-align: center;
                width: 80px;
                font-weight: bold;
                font-size: 16px;
                height: 40px;
                border: none;
            }

            .call {
                color: #0FBC54;
                margin-right: 10px;
            }
        }


    }

    .patient-info-content {
        padding: 0px 26px;

        .cells {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;

            .cell {
                width: 50%;
                display: flex;
                margin-bottom: 14px;

                &.full {
                    width: 100%;
                }

                .label {
                    flex: none;
                    margin-right: 20px;
                    color: #999;
                }
            }
        }
    }

    .van-col {
        font-size: 14px;
        margin-bottom: 14px;

        span {
            &:first-child {
                color: #999;
                margin-right: 20px;
            }
        }
    }

    .patient-info-footer {
        padding: 18px 0;
        background: #F6FBFF;
        display: flex;
        font-size: 16px;
        flex-wrap: wrap;

        div {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            flex: 1;
        }

        .follow-up {
            color: #F59A23;
            border-right: 1px solid #E1E8EF;
        }

        .inquiry {
            color: #0082EF;
            border-right: 1px solid #E1E8EF;
        }

        .medicated {
            color: #ff6e4a;
            border-right: 1px solid #E1E8EF;
        }

        .tracking {
            color: #6764FF;
            border-right: 1px solid #E1E8EF;
        }

        .createAsk {
            color: #3399ff;
            border-right: 1px solid #E1E8EF;
        }

        .more {
            color: #0FBC54;
        }
    }
}

.pagination {
    padding: 20px 0;
}

.relation {
    margin-left: 10px;
}

.relation-list {
    padding: 5px;

    .itm {
        margin-top: 5px;

        &:first-child {
            margin-top: 0;
        }

        .van-button {
            padding: 5px 10px;
        }
    }
}

.vip-equity {
    margin-bottom: 15px;
}
</style>